/* global femcare */

femcare.form.phoneInput = {
    /**
     * Initializes the phone input functionality.
     */
    init() {
        this.addPrefixClickEvent();
        this.addCountrySearchFunctionality();
        this.addOutsideCountryClickHandler();
        this.addCountryClickHandler();
        $('form').on('submit', (e) => this.onSubmit(e));
    },

    /**
     * Adds a click event to the phone number prefix button to toggle the country code selection.
     */
    addPrefixClickEvent() {
        $('.phone-number__country-code').on('click', function () {
            const $phoneArea = $('.phone-area');
            const isExpanded = $phoneArea.hasClass('displayed');

            // Use a direct reference to the clicked element
            const $prefixButton = $(this);

            $phoneArea.toggleClass('displayed');
            $prefixButton.attr('aria-expanded', !isExpanded);
        });
    },

    /**
     * Adds search functionality to filter country elements.
     */
    addCountrySearchFunctionality() {
        const debouncedSearch = femcare.shared.util.debounce(() => {
            const searchText = $('.phone-area__search').val().toLowerCase();
            $('.phone-area .phone-area__country').each(function () {
                const countryName = $(this).find('.phone-area__country-name').text().toLowerCase();
                $(this).toggle(countryName.includes(searchText));
            });
        }, 300);

        $('.phone-area__search').on('input', debouncedSearch);
    },

    /**
     * Adds an outside click handler to hide the phone area when clicking outside.
     */
    addOutsideCountryClickHandler() {
        $(document).on('click', (e) => {
            const $phoneArea = $('.phone-area');
            const $prefixButton = $('.phone-number__country-code');
            if (!$phoneArea.is(e.target) && $phoneArea.has(e.target).length === 0 && !$prefixButton.is(e.target)) {
                $phoneArea.removeClass('displayed');
                $prefixButton.attr('aria-expanded', 'false');
            }
        });
    },

    /**
     * Adds a click event handler to country elements to select a country.
     */
    addCountryClickHandler() {
        $('.phone-area__country').on('click', function () {
            const $selectedCountry = $(this);
            const countryPrefix = $selectedCountry.data('country-prefix');
            const countryImage = $selectedCountry.find('.phone-area__country-flag').attr('src');

            // Update the hidden prefix input value
            $('.phone-number__country-code-input').val(`+${countryPrefix}`);

            // Update the phone-number__country-code with the selected country's image and number
            const $prefixButton = $('.phone-number__country-code');
            $prefixButton.find('.phone-area__country-flag').attr('src', countryImage);
            $prefixButton.find('.phone-area__country-number').text(`(+${countryPrefix})`);
            $prefixButton.attr('aria-expanded', 'false');

            // Remove selected style from previously selected country and add to the current selection
            $('.phone-area__country--selected').removeClass('phone-area__country--selected');
            $selectedCountry.addClass('phone-area__country--selected');

            $('.phone-area').removeClass('displayed');
            $('.phone-number__input').trigger('focus');
        });
    },


    /**
     * Submit event handler to concatenate prefix with phone number.
     * @param {Event} e - The submit event.
     */
    onSubmit(e) {
        const $form = $(e.target);
        femcare.shared.inputs.mergeMultiInputField($form);
    }
};
